import { Site, WebSiteApi } from '@api/model';
import { DefaultHttpService } from './HttpService';

class WebSiteService {
  readonly webSiteApi = new WebSiteApi(new DefaultHttpService());

  public crateSite(site: Site): Promise<any> {
    return this.webSiteApi.createSite(site);
  }

  public deleteSite(id: number): Promise<any> {
    return this.webSiteApi.deleteSite(id);
  }

  public getSites(): Promise<Site[]> {
    return this.webSiteApi.getSites();
  }

  public updateSite(site: Site): Promise<any> {
    return this.webSiteApi.updateSite(site);
  }
}

export default new WebSiteService();
